const defaultOrderTypesReducer = (defaultOrderTypes = {}, action) => {
    switch (action.type) {
        case "ADD_DEFAULT_ORDER_TYPES":
            return action.payload;
        default:
            return defaultOrderTypes;
    }
};

export default defaultOrderTypesReducer;